import type { SVGProps } from 'react';

interface CheckCircleFilledIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CheckCircleFilledIcon({
  className,
  ...props
}: CheckCircleFilledIconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M18 9C18 13.9705 13.9705 18 9 18C4.02955 18 0 13.9705 0 9C0 4.02955 4.02955 0 9 0C13.9705 0 18 4.02955 18 9ZM6.795 13.9991L14.4875 6.30573L13.3306 5.14882L6.88091 11.5985L4.85509 9.13582L3.61882 10.2076L6.795 13.9983V13.9991Z"
        fill="currentColor"
      />
    </svg>
  );
}
